import { render, staticRenderFns } from "./video-wrapper.vue?vue&type=template&id=6e6e47c5"
import script from "./video-wrapper.vue?vue&type=script&lang=js"
export * from "./video-wrapper.vue?vue&type=script&lang=js"
import style0 from "./video-wrapper.vue?vue&type=style&index=0&id=6e6e47c5&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/binhdoan/Work/Dev-gits/Shopify-KL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6e47c5')) {
      api.createRecord('6e6e47c5', component.options)
    } else {
      api.reload('6e6e47c5', component.options)
    }
    module.hot.accept("./video-wrapper.vue?vue&type=template&id=6e6e47c5", function () {
      api.rerender('6e6e47c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/video-wrapper.vue"
export default component.exports